import { useElementVisibility } from '@vueuse/core'

/**
 * Provides a convenient way to render parts of a component only when it becomes visible.
 *
 * The composable tracks the visibility of the root element of the current component.
 * This composable should only be used when the component has a single root element.
 */
export default function (el: Ref<HTMLElement | null | undefined>) {
  // Track visibility.
  const isVisible = useElementVisibility(el)
  const shouldRender = ref(isVisible.value)

  // Set the value once the element becomes visible.
  watch(isVisible, function (value) {
    if (value) {
      shouldRender.value = true
    }
  })

  return readonly(shouldRender)
}
